import React,{useState} from 'react'
import JSONDATA from './genes.json';
export default function Kidney() {
    const [geneName, setGeneName] = React.useState('');
  return (
    <div className="wrapper">
      <input type="text" placeholder="seach..." onChange={e=>setGeneName(e.target.value)} />
      {JSONDATA.filter((val)=>{
        if(geneName === ""){
          return false
        }
        else if(val.name.toLowerCase() === geneName.toLowerCase()){
          return val;
        }
      }).map((val,key)=>{

        return <div key={val.name}>
                         <div>
                         <img 
                             src={"https://s3.us-east-2.amazonaws.com/ksusztak.genemap/02/kv2/UMAP_kidney_v2.png"} 
                             style={{ width: "32%", height: "100%" }} 
                             alt="umap"
                         />
                         <img 
                             src={"https://s3.us-east-2.amazonaws.com/ksusztak.genemap/02/kv2/"+ val.images.dotplot+".jpeg"} 
                             style={{ width: "68%", height: "100%" }} 
                             alt="Dotplot"
                         />
                         </div>
                         <div>
                         <img 
                             src={"https://s3.us-east-2.amazonaws.com/ksusztak.genemap/02/kv2/"+ val.images.featureplot+".jpeg"} 
                             style={{ width: "100%", height: "100%" }} 
                             alt="Feature Plot"
                         />
                         </div>
	</div>
      })}
    </div>
  );
}
